import { render, staticRenderFns } from "./SendPartials.vue?vue&type=template&id=493bb870&"
import script from "./SendPartials.vue?vue&type=script&lang=js&"
export * from "./SendPartials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports